import { WAIT_FOR_ACTION, ERROR_ACTION, CALLBACK_ARGUMENT } from "redux-wait-for-action";
import { SEND_PROSPECT_TO_API_SUCCESS, SEND_PROSPECT_TO_API_FAIL } from "./sendProspectToAPI";
export const SEND_DROPOFF_AUTHORIZATION_REQUEST = "SEND_DROPOFF_AUTHORIZATION_REQUEST";
export const sendDropoffAuthorizePromisify = () => {
  return {
    type: SEND_DROPOFF_AUTHORIZATION_REQUEST,
    [WAIT_FOR_ACTION]: SEND_PROSPECT_TO_API_SUCCESS,
    [ERROR_ACTION]: SEND_PROSPECT_TO_API_FAIL,
    [CALLBACK_ARGUMENT]: action => action.payload
  };
};
